import * as React from "react";
import { BeeDetailsView } from "./details";
import {  DetailsProvider } from "./state/detailsContext";


export function DetailsContainer(){
    return <DetailsProvider>
        <BeeDetailsView />
    </DetailsProvider>
}